import React, { lazy } from "react";
import ViewWrapper from "../ViewWrapper/ViewWrapper";
// import Technologies from "./Technologies";
const Technologies = lazy(() => import("./Technologies"));
interface Props extends React.HTMLAttributes<HTMLDivElement> {
    ref?: React.LegacyRef<HTMLDivElement>;
    inView?: boolean;
}

const TechnologiesWrapper: React.FC<Props> = ({ ref = null, inView = true }) => {
    return (
        <ViewWrapper ref={ref} inView={inView}>
            <Technologies />
        </ViewWrapper>
    );
};

export default TechnologiesWrapper;
